<h2 mat-dialog-title>Save as New List</h2>

<mat-dialog-content class="tw-pt-4 tw-pb-0">
  <div class="tw-flex tw-flex-col tw-gap-4">
    <mat-form-field appearance="outline" class="tw-w-full">
      <mat-label>List Name</mat-label>
      <input matInput [formControl]="nameControl" trim placeholder="Enter list name" />
      <mat-error *ngIf="nameControl.invalid && (nameControl.dirty || nameControl.touched)">
        <span *ngIf="nameControl.errors?.['required']">List name is required</span>
        <span *ngIf="nameControl.errors?.['minlength']">List name cannot be empty</span>
      </mat-error>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="tw-p-4">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSave()" [disabled]="nameControl.invalid">
    Save
  </button>
</mat-dialog-actions>
